import request from '../../utils/request'
const insuranceList = (parmer) => {
    let userId = parmer.userId,
        page = parmer.page,
        size = parmer.size
    return request({
        url: process.env.VUE_APP_API + `policy/list/${page}`,
        // url: process.env.VUE_APP_API + `policy/list/${size}/${page}`,
        method: 'get',
    })
}
const insureInfo = (uuid,type) => {
    return request({
        url: process.env.VUE_APP_API + `policy/info/${uuid}?type=${type}&sjc=${Date.parse(new Date())}`,
        method: 'get',
    })
}
const expensesInfo = (uuid) => {
    return request({
        url: process.env.VUE_APP_API + `policy/expenses/${uuid}?sjc=${Date.parse(new Date())}`,
        method: 'get',
    })
}
export {
    insuranceList,
    insureInfo,
    expensesInfo
}